import React, { useState } from "react";
import SimpleLabelValue from "../../SimpleLabelValue";
import { useNavigate } from "react-router-dom";
import { useStepper } from "../StepperContext";
import "./style.scss";
import axios from "axios";

const PayForm = () => {
  const { invoice } = useStepper();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const BaseUrl = process.env.REACT_APP_BASE_URL;

  console.log("📋 Full Invoice Data:", invoice);

  const handlePayment = async () => {
    const type = "reservation";
    const id = invoice.room_invoices[0]?.room_id; // Safe access
    
    // ✅ VALIDATION
    if (!invoice?.total_invoice || invoice.total_invoice <= 0) {
      alert("Invalid invoice amount!");
      return;
    }
    if (!id) {
      alert("Room ID not found!");
      return;
    }

    try {
      setLoading(true);
      const token = localStorage.getItem("token");

      console.log("🚀 Sending Payment Request:", {
        amount: invoice.total_invoice,
        type,
        id,
        token: token ? "present" : "missing"
      });

      const response = await axios.post(
        `${BaseUrl}/paypal/create-payment`,
        {
          amount: parseFloat(invoice.total_invoice), // ✅ Number format
          return_url: `https://eventscons.com/success/${type}/${id}/0`,
          cancel_url: `https://eventscons.com/failed`,
        },
        { 
          headers: { 
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json" // ✅ Added
          } 
        }
      );

      console.log("✅ PayPal Response:", response.data);

      const orderID = response.data.id;
      
      // ✅ SANDBOX URL - Correct format
      const paypalUrl = `https://www.sandbox.paypal.com/checkoutnow?token=${orderID}`;
      console.log("🔗 Redirecting to:", paypalUrl);
      
      window.location.href = paypalUrl;

    } catch (error) {
      console.error("❌ Payment Error Details:", error.response?.data || error.message);
      
      // ✅ Better error messages
      if (error.response?.status === 401) {
        alert("Session expired! Please login again.");
      } else if (error.response?.status === 400) {
        alert("Invalid payment data. Please check invoice.");
      } else if (error.response?.status === 422) {
        alert("Payment amount invalid. Contact support.");
      } else {
        alert("Payment failed. Please try again or contact support.");
      }
    } finally {
      setLoading(false);
    }
  };

  if (!invoice) {
    return <div>No invoice data available</div>;
  }

  return (
    <div className="pay-form-container">
      <div className="pay-form-invoice-details">
        <h3>🧾 Invoice Details</h3>
        <div className="pay-form-section">
          <SimpleLabelValue label="Reservation ID" value={invoice.reservation_id || "N/A"} />
          <SimpleLabelValue label="Invoice ID" value={invoice.id || "N/A"} />
          <SimpleLabelValue 
            label="Total Amount" 
            value={`$${parseFloat(invoice.total_invoice || 0).toFixed(2)}`} 
          />
        </div>

        <h3>🏨 Room Breakdown</h3>
        {invoice.room_invoices?.map((room, index) => (
          <div key={index} className="pay-form-section">
            <SimpleLabelValue label="Room Type" value={room.room_type || "N/A"} />
            <SimpleLabelValue label="Room ID" value={room.room_id || "N/A"} />
            <SimpleLabelValue 
              label="Base Price" 
              value={`$${parseFloat(room.base_price || 0).toFixed(2)}`} 
            />
            <SimpleLabelValue 
              label="Total Cost" 
              value={`$${parseFloat(room.total_cost || 0).toFixed(2)}`} 
            />
          </div>
        ))}
      </div>

      {invoice.total_invoice > 0 && (
        <div className="actions-section">
          <button 
            className={`next-button ${loading ? "disabled" : ""}`}
            onClick={handlePayment}
            disabled={loading}
          >
            {loading ? "⏳ Processing..." : `💳 Pay $${parseFloat(invoice.total_invoice).toFixed(2)}`}
          </button>
        </div>
      )}
    </div>
  );
};

export default PayForm;
